<template>
  <div>
    <!-- 筛选器区域 -->
    <div
      class="filter_section"
      :class="{ empty: filterCategories.length === 0 }"
    >
      <div class="filter_container" v-show="filterCategories.length > 0">
        <!-- 动态生成筛选器 -->
        <div
          class="filter_item"
          v-for="(category, index) in filterCategories"
          :key="category.key"
          :class="{ active: hasSelectedFilters(category.key) }"
          @click="selectSchoolType(index)"
        >
          <div class="filter_label">{{ category.name }}</div>
          <div class="filter_arrow"></div>
        </div>
        <!-- 占位内容：当没有筛选数据时显示空白占位 -->
        <div
          v-if="filterCategories.length === 0"
          class="filter_placeholder"
        ></div>
      </div>
    </div>

    <!--筛选弹层-->
    <div class="filter_popup_bg" v-if="isShowPopupList">
      <div class="filter_popup_content">
        <!-- 弹层头部 -->
        <div class="filter_popup_header">
          <span class="filter_popup_title">筛选条件</span>
          <div class="filter_popup_close" @click="closePopupList"></div>
        </div>

        <!-- 分类标签 -->
        <div class="filter_categories" ref="filterCategoriesContainer">
          <div
            class="filter_category_item"
            v-for="(category, index) in filterCategories"
            :key="index"
            :class="{ active: currentFilterCategory === index }"
            :data-category-index="index"
            @click="switchFilterCategory(index)"
          >
            {{ category.name }}
          </div>
        </div>

        <!-- 筛选内容区域 -->
        <div class="filter_content_area">
          <!-- Loading 状态 -->
          <div class="filter_loading" v-if="isLoadingFilterData">
            <div class="loading_container">
              <img
                src="https://g.xdfimage.cn/upload/ab3657e30542c5e9b6290ae52f283f41.gif"
                alt="加载中"
                class="loading_gif"
              />
              <div class="loading_text">加载中</div>
            </div>
          </div>

          <!-- 地点二级筛选 -->
          <div
            v-if="filterCategories[currentFilterCategory].key === 'area'"
            class="area_filter_container"
          >
            <!-- 左侧：地区列表 -->
            <div class="area_list">
              <div
                class="area_item"
                v-for="(area, index) in currentFilterOptions"
                :key="index"
                :class="{
                  active: selectedArea && selectedArea.key === area.key,
                }"
                @click="selectFilterOption(area)"
              >
                {{ area.name }}
                <!-- 扇形装饰元素 - 只在active状态显示 -->
                <div
                  v-if="selectedArea && selectedArea.key === area.key"
                  class="sector-90"
                ></div>
                <div
                  v-if="selectedArea && selectedArea.key === area.key"
                  class="sector-90"
                ></div>
              </div>
            </div>
            <!-- 右侧：校区列表 -->
            <div
              class="campus_list"
              v-if="selectedArea && selectedArea.subValues"
            >
              <div
                class="campus_item"
                v-for="(campus, index) in selectedArea.subValues"
                :key="index"
                @click="selectCampus(campus)"
              >
                <div class="campus_checkbox">
                  <div
                    class="checkbox"
                    :class="{ checked: isCampusSelected(campus) }"
                  ></div>
                </div>
                <div class="campus_text">{{ campus.name }}</div>
              </div>
            </div>
          </div>
          <!-- 时间三级筛选 -->
          <div
            v-else-if="filterCategories[currentFilterCategory].key === 'time'"
            class="time_filter_container"
          >
            <!-- 无选项时显示全宽提示 -->
            <div
              v-if="currentFilterOptions.length === 0"
              class="no-filter-options"
            >
              暂无选项，调整已选条件试试吧～
            </div>
            <!-- 有选项时显示左右分栏 -->
            <template v-else>
              <!-- 左侧：季节/假期列表 -->
              <div class="time_season_list">
                <div
                  class="time_season_item"
                  v-for="(season, index) in currentFilterOptions"
                  :key="index"
                  :class="{
                    active:
                      selectedTimeSeason &&
                      selectedTimeSeason.key === season.key,
                  }"
                  @click="selectFilterOption(season)"
                >
                  {{ season.name }}
                  <!-- 扇形装饰元素 - 只在active状态显示 -->
                  <div
                    v-if="
                      selectedTimeSeason &&
                      selectedTimeSeason.key === season.key
                    "
                    class="sector-90"
                  ></div>
                  <div
                    v-if="
                      selectedTimeSeason &&
                      selectedTimeSeason.key === season.key
                    "
                    class="sector-90"
                  ></div>
                </div>
              </div>
              <!-- 右侧：所有期次和时间段 -->
              <div
                class="time_content_area"
                v-if="selectedTimeSeason && selectedTimeSeason.subValues"
              >
                <!-- 期次标签 -->
                <div class="time_phase_tabs">
                  <div
                    class="time_phase_tab"
                    v-for="(phase, index) in selectedTimeSeason.subValues"
                    :key="index"
                    :data-phase-key="phase.key"
                    :class="{
                      active:
                        selectedTimePhase &&
                        selectedTimePhase.key === phase.key,
                    }"
                    @click="selectTimePhase(phase)"
                  >
                    {{ phase.name }}
                  </div>
                </div>
                <!-- 所有期次的时间段列表 -->
                <div
                  class="time_slots_list"
                  ref="timeSlotsList"
                  @scroll="handleTimeSlotsScroll"
                >
                  <div
                    v-for="(phase, phaseIndex) in selectedTimeSeason.subValues"
                    :key="phaseIndex"
                    class="phase_section"
                    :data-phase-section="phase.key"
                  >
                    <!-- 期次标题 -->
                    <div class="phase_title">{{ phase.name }}</div>
                    <!-- 该期次的时间段 -->
                    <div
                      class="time_slot_item"
                      v-for="(slot, slotIndex) in phase.subValues"
                      :key="slotIndex"
                      :data-timeslot-key="slot.key"
                      @click="selectTimeSlot(slot)"
                    >
                      <div class="time_slot_checkbox">
                        <div
                          class="checkbox"
                          :class="{ checked: isTimeSlotSelected(slot) }"
                        ></div>
                      </div>
                      <div class="time_slot_text">{{ slot.name }}</div>
                    </div>
                  </div>
                </div>
              </div>
            </template>
          </div>
          <!-- 教师筛选特殊处理：带字母分组和锚点 -->
          <div
            v-else-if="
              filterCategories[currentFilterCategory].key === 'teacher'
            "
            class="teacher_filter_container"
          >
            <!-- 教师列表区域 -->
            <div
              class="teacher_list_area"
              ref="teacherListArea"
              @scroll="handleTeacherListScroll"
            >
              <div
                v-if="currentFilterOptions.length === 0"
                class="no-filter-options"
              >
                暂无选项，调整已选条件试试吧～
              </div>
              <div
                v-for="(group, letter) in groupedTeachers"
                :key="letter"
                class="teacher_group"
                :data-letter="letter"
              >
                <!-- 字母分组标题 -->
                <div class="teacher_group_title">{{ letter }}</div>
                <!-- 该字母下的教师列表 -->
                <div
                  class="filter_option_item"
                  v-for="(item, index) in group"
                  :key="index"
                  @click="selectFilterOption(item)"
                >
                  <div class="filter_option_checkbox">
                    <div
                      class="checkbox"
                      :class="{ checked: isOptionSelected(item) }"
                    ></div>
                  </div>
                  <!-- 教师头像 -->
                  <div v-if="item.logo" class="teacher_avatar">
                    <img
                      :src="item.logo"
                      :alt="item.name"
                      @error="handleAvatarError"
                    />
                  </div>
                  <div class="filter_option_text">
                    {{ item.name || item }}
                  </div>
                </div>
              </div>
            </div>
            <!-- 右侧字母锚点导航 -->
            <div class="letter_anchor_nav">
              <div
                class="letter_anchor_item"
                v-for="letter in availableLetters"
                :key="letter"
                :class="{ active: currentLetter === letter }"
                @click="scrollToLetter(letter)"
              >
                {{ letter }}
              </div>
            </div>
          </div>
          <!-- 其他筛选选项列表 -->
          <div v-else class="filter_options_list">
            <div
              v-if="currentFilterOptions.length === 0"
              class="no-filter-options"
            >
              暂无选项，调整已选条件试试吧～
            </div>
            <div
              class="filter_option_item"
              v-for="(item, index) in currentFilterOptions"
              :key="index"
              @click="selectFilterOption(item)"
            >
              <div class="filter_option_checkbox">
                <div
                  class="checkbox"
                  :class="{ checked: isOptionSelected(item) }"
                ></div>
              </div>
              <div class="filter_option_text">{{ item.name || item }}</div>
            </div>
          </div>
        </div>

        <!-- 已选标签 -->
        <div
          class="selected_filters"
          v-if="
            tempSelectedFilters.length > 0 ||
            tempSelectedCampuses.length > 0 ||
            tempSelectedTimeSlots.length > 0
          "
        >
          <!-- 普通筛选标签 -->
          <div
            class="selected_filter_tag"
            v-for="(filter, index) in tempSelectedFilters"
            :key="'filter-' + index"
          >
            <span class="tag_text">{{ filter.name || filter }}</span>
            <span
              class="tag_remove"
              @click="removeSelectedFilter(index)"
            ></span>
          </div>
          <!-- 校区筛选标签 -->
          <div
            class="selected_filter_tag"
            v-for="(campus, index) in tempSelectedCampuses"
            :key="'campus-' + index"
          >
            <span class="tag_text">{{ campus.name }}</span>
            <span
              class="tag_remove"
              @click="removeSelectedCampus(index)"
            ></span>
          </div>
          <!-- 时间段筛选标签 -->
          <div
            class="selected_filter_tag"
            v-for="(slot, index) in tempSelectedTimeSlots"
            :key="'timeslot-' + index"
          >
            <span class="tag_text" @click="scrollToTimePhase(slot.phaseKey)">{{
              slot.name
            }}</span>
            <span
              class="tag_remove"
              @click="removeSelectedTimeSlot(index)"
            ></span>
          </div>
        </div>

        <!-- 底部操作按钮 -->
        <div class="filter_popup_actions">
          <button class="reset_btn" @click="resetFilters">重置</button>
          <button class="confirm_btn" @click="confirmFilters">
            {{ confirmButtonText }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGeneralFilter } from "@/libs/api.js";

export default {
  name: "CourseFilter",
  props: {
    // 是否是套餐页面
    isPackage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      // 活动ID
      activityId: null,
      // 筛选数据存储
      areaFilters: [], // 地区筛选器数据
      gradeFilters: [], // 年级筛选器数据
      subjectFilters: [], // 科目筛选器数据
      teacherFilters: [], // 教师筛选器数据
      timeFilters: [], // 时间筛选器数据
      custom1Filters: [], // 自定义筛选器1数据
      custom2Filters: [], // 自定义筛选器2数据
      custom3Filters: [], // 自定义筛选器3数据
      custom4Filters: [], // 自定义筛选器4数据
      custom1FilterName: "", // 自定义筛选器1名称
      custom2FilterName: "", // 自定义筛选器2名称
      custom3FilterName: "", // 自定义筛选器3名称
      custom4FilterName: "", // 自定义筛选器4名称
      // 筛选弹层相关数据
      isShowPopupList: false, // 是否显示弹窗列表
      currentFilterCategory: 0, // 当前选中的分类
      currentFilterOptions: [], // 当前分类的选项
      selectedFilters: [], // 已选择的筛选条件（确认后的状态）
      filteredCourseCount: 0, // 筛选后的课程数量
      // 二级筛选相关数据
      selectedArea: null, // 当前选中的地区
      selectedCampuses: [], // 当前选中的校区（确认后的状态）
      // 三级筛选相关数据（时间筛选）
      selectedTimeSeason: null, // 当前选中的季节/假期
      selectedTimePhase: null, // 当前选中的期次
      selectedTimeSlots: [], // 当前选中的具体时间段（确认后的状态）

      // 临时筛选状态（弹层中选择时使用，只有确认后才应用到实际状态）
      tempSelectedFilters: [], // 临时已选择的筛选条件
      tempSelectedCampuses: [], // 临时已选择的校区
      tempSelectedTimeSlots: [], // 临时已选择的时间段

      // 教师筛选字母锚点相关
      currentLetter: "", // 当前激活的字母
      // 初始筛选分类列表（用于保持面板显示，即使没有数据）
      initialFilterCategories: [], // 初始筛选分类列表
      // 筛选数据加载状态
      isLoadingFilterData: false, // 是否正在加载筛选数据
    };
  },
  computed: {
    // 动态生成筛选分类，保持初始分类显示，即使没有数据
    filterCategories() {
      // 如果已经有初始分类列表，使用它（保持所有维度显示）
      if (this.initialFilterCategories.length > 0) {
        return this.initialFilterCategories.map((category) => {
          // 更新名称（对于自定义筛选，名称可能会变化）
          if (category.key === "custom1" && this.custom1FilterName) {
            return { ...category, name: this.custom1FilterName };
          }
          if (category.key === "custom2" && this.custom2FilterName) {
            return { ...category, name: this.custom2FilterName };
          }
          if (category.key === "custom3" && this.custom3FilterName) {
            return { ...category, name: this.custom3FilterName };
          }
          if (category.key === "custom4" && this.custom4FilterName) {
            return { ...category, name: this.custom4FilterName };
          }
          return category;
        });
      }

      // 如果没有初始分类列表，则按原有逻辑生成（首次加载时）
      const categories = [];

      // 地点筛选
      if (this.areaFilters && this.areaFilters.length > 0) {
        categories.push({ name: "校区", key: "area" });
      }

      // 年级筛选
      if (this.gradeFilters && this.gradeFilters.length > 0) {
        categories.push({ name: "年级", key: "grade" });
      }

      // 科目筛选
      if (this.subjectFilters && this.subjectFilters.length > 0) {
        categories.push({ name: "科目", key: "subject" });
      }

      // 教师筛选
      if (this.teacherFilters && this.teacherFilters.length > 0) {
        categories.push({ name: "教师", key: "teacher" });
      }

      // 时间筛选
      if (this.timeFilters && this.timeFilters.length > 0) {
        categories.push({ name: "时间", key: "time" });
      }

      // 自定义筛选1
      if (
        this.custom1Filters &&
        this.custom1Filters.length > 0 &&
        this.custom1FilterName
      ) {
        categories.push({ name: this.custom1FilterName, key: "custom1" });
      }

      // 自定义筛选2
      if (
        this.custom2Filters &&
        this.custom2Filters.length > 0 &&
        this.custom2FilterName
      ) {
        categories.push({ name: this.custom2FilterName, key: "custom2" });
      }

      // 自定义筛选3
      if (
        this.custom3Filters &&
        this.custom3Filters.length > 0 &&
        this.custom3FilterName
      ) {
        categories.push({ name: this.custom3FilterName, key: "custom3" });
      }

      // 自定义筛选4
      if (
        this.custom4Filters &&
        this.custom4Filters.length > 0 &&
        this.custom4FilterName
      ) {
        categories.push({ name: this.custom4FilterName, key: "custom4" });
      }

      return categories;
    },
    // 按拼音首字母分组的教师列表
    groupedTeachers() {
      const category = this.filterCategories[this.currentFilterCategory];
      if (!category || category.key !== "teacher") {
        return {};
      }

      const grouped = {};
      this.currentFilterOptions.forEach((teacher) => {
        // 获取拼音首字母，转为大写
        let firstLetter = "";
        if (teacher.pinyinName) {
          firstLetter = teacher.pinyinName.charAt(0).toUpperCase();
        } else if (teacher.name) {
          // 如果没有 pinyinName，使用 name 的首字符
          firstLetter = teacher.name.charAt(0).toUpperCase();
        }

        // 检查是否是字母，如果不是则归类到 '#'
        if (!/[A-Z]/.test(firstLetter)) {
          firstLetter = "#";
        }

        if (!grouped[firstLetter]) {
          grouped[firstLetter] = [];
        }
        grouped[firstLetter].push(teacher);
      });

      // 按字母顺序排序
      const sortedGrouped = {};
      Object.keys(grouped)
        .sort((a, b) => {
          if (a === "#") return 1;
          if (b === "#") return -1;
          return a.localeCompare(b);
        })
        .forEach((key) => {
          sortedGrouped[key] = grouped[key];
        });

      return sortedGrouped;
    },
    // 可用的字母列表
    availableLetters() {
      return Object.keys(this.groupedTeachers);
    },
    // 确认按钮文本
    confirmButtonText() {
      const unit = "班级";
      return `确定 (${this.filteredCourseCount}个${unit})`;
    },
  },
  watch: {
    // 监听筛选分类变化，确保当前选中的分类索引有效
    filterCategories: {
      handler(newCategories) {
        // 如果当前选中的分类索引超出了新分类的范围，重置为0
        if (this.currentFilterCategory >= newCategories.length) {
          this.currentFilterCategory = 0;
        }
        // 更新当前分类的选项
        this.updateCurrentFilterOptions();
      },
      immediate: true,
    },
  },
  mounted() {
    // 从URL获取activityId
    this.getActivityIdFromUrl();
    // 组件挂载后，获取筛选数据
    this.getFilterData();
    // 为时间筛选区域添加滚动监听
    this.$nextTick(() => {
      this.addScrollListener();
    });
  },
  beforeDestroy() {
    // 组件销毁前，移除滚动监听器
    this.removeScrollListener();
  },
  methods: {
    // 从URL获取activityId
    getActivityIdFromUrl() {
      // 直接从路由查询参数获取activityId
      this.activityId =
        this.$route.query.activityId || this.$route.query.activity_id;

      console.log("从URL获取的activityId:", this.activityId);

      if (!this.activityId) {
        console.warn("无法从URL获取activityId");
      }
    },
    // 获取筛选数据
    getFilterData(filterParams = null, skipKey = null, currentIndex = null) {
      if (!this.activityId) {
        console.warn("activityId为空，无法获取筛选数据");
        return;
      }

      // 构建请求参数，和 getFilterClassCount 一致
      const params = {
        activityId: parseInt(this.activityId),
        areaFilters: filterParams?.areaFilters || [],
        timeFilters: filterParams?.timeFilters || [],
        gradeFilters: filterParams?.gradeFilters || [],
        subjectFilters: filterParams?.subjectFilters || [],
        teacherFilters: filterParams?.teacherFilters || [],
        custom1Filters: filterParams?.custom1Filters || [],
        custom2Filters: filterParams?.custom2Filters || [],
        custom3Filters: filterParams?.custom3Filters || [],
        custom4Filters: filterParams?.custom4Filters || [],
      };

      // 显示 loading
      this.isLoadingFilterData = true;

      console.log(
        "调用筛选接口，参数:",
        params,
        "跳过维度:",
        skipKey,
        "当前索引:",
        currentIndex
      );
      getGeneralFilter(params)
        .then((res) => {
          let resData = res;

          // 检查响应格式，适配不同的返回格式
          if (resData.code == 1 || resData.status == 200 || resData.data) {
            // 直接处理筛选数据，只更新后面的维度
            console.log("筛选数据:", resData.data);
            this.processFilterData(resData.data, skipKey, currentIndex);
          } else {
            console.warn("接口返回异常:", resData);
          }
        })
        .catch((error) => {
          console.error("获取筛选数据失败:", error);
        })
        .finally(() => {
          // 隐藏 loading
          this.isLoadingFilterData = false;
        });
    },
    // 获取当前已选择的筛选参数（用于级联调用）
    getCurrentFilterParams() {
      return {
        areaFilters: this.tempSelectedCampuses.map((campus) => campus.key),
        timeFilters: this.tempSelectedTimeSlots.map((slot) => slot.key),
        gradeFilters: this.getSelectedFiltersByType("grade"),
        subjectFilters: this.getSelectedFiltersByType("subject"),
        teacherFilters: this.getSelectedFiltersByType("teacher"),
        custom1Filters: this.getSelectedFiltersByType("custom1"),
        custom2Filters: this.getSelectedFiltersByType("custom2"),
        custom3Filters: this.getSelectedFiltersByType("custom3"),
        custom4Filters: this.getSelectedFiltersByType("custom4"),
      };
    },
    // 获取当前维度的索引
    getCategoryIndex(categoryKey) {
      return this.filterCategories.findIndex((cat) => cat.key === categoryKey);
    },
    // 刷新后面维度的筛选选项（级联）
    refreshLaterDimensions(currentCategoryIndex) {
      const currentCategory = this.filterCategories[currentCategoryIndex];
      if (!currentCategory) return;

      // 清空后面维度的已选项（先清空，再获取新数据）
      const currentKey = currentCategory.key;
      const categoryKeys = this.filterCategories.map((cat) => cat.key);
      const currentIndex = categoryKeys.indexOf(currentKey);

      // 清空当前维度之后的所有维度的已选项
      for (let i = currentIndex + 1; i < this.filterCategories.length; i++) {
        const laterCategory = this.filterCategories[i];
        if (!laterCategory) continue;

        switch (laterCategory.key) {
          case "area":
            // 清空校区选择
            this.tempSelectedCampuses = [];
            this.selectedArea = null;
            break;
          case "time":
            // 清空时间选择
            this.tempSelectedTimeSlots = [];
            this.selectedTimeSeason = null;
            this.selectedTimePhase = null;
            break;
          case "grade":
          case "subject":
          case "teacher":
          case "custom1":
          case "custom2":
          case "custom3":
          case "custom4": {
            // 清空对应类型的筛选
            const laterCategoryKey = laterCategory.key;
            this.tempSelectedFilters = this.tempSelectedFilters.filter(
              (filter) => {
                const filterKey = filter.key || filter.name;
                switch (laterCategoryKey) {
                  case "grade":
                    return !(
                      this.gradeFilters &&
                      this.gradeFilters.some((item) => item.key === filterKey)
                    );
                  case "subject":
                    return !(
                      this.subjectFilters &&
                      this.subjectFilters.some(
                        (item) => (item.key || item.name) === filterKey
                      )
                    );
                  case "teacher":
                    return !(
                      this.teacherFilters &&
                      this.teacherFilters.some(
                        (item) =>
                          (item.key || item.code || item.name) === filterKey
                      )
                    );
                  case "custom1":
                    return !(
                      this.custom1Filters &&
                      this.custom1Filters.some(
                        (item) => (item.key || item.name) === filterKey
                      )
                    );
                  case "custom2":
                    return !(
                      this.custom2Filters &&
                      this.custom2Filters.some(
                        (item) => (item.key || item.name) === filterKey
                      )
                    );
                  case "custom3":
                    return !(
                      this.custom3Filters &&
                      this.custom3Filters.some(
                        (item) => (item.key || item.name) === filterKey
                      )
                    );
                  case "custom4":
                    return !(
                      this.custom4Filters &&
                      this.custom4Filters.some(
                        (item) => (item.key || item.name) === filterKey
                      )
                    );
                  default:
                    return true;
                }
              }
            );
            break;
          }
        }
      }

      // 获取当前已选择的筛选参数（清空后重新获取）
      const filterParams = this.getCurrentFilterParams();

      // 重新获取筛选数据，只更新后面的维度
      this.getFilterData(filterParams, currentKey, currentIndex);
    },
    // 处理筛选数据
    processFilterData(filterData, skipKey = null, currentIndex = null) {
      console.log(
        "开始处理筛选数据:",
        filterData,
        "跳过维度:",
        skipKey,
        "当前索引:",
        currentIndex
      );

      // 如果是首次加载（没有初始分类列表），保存初始分类列表
      if (this.initialFilterCategories.length === 0) {
        const categories = [];
        if (filterData.areaFilters && filterData.areaFilters.length > 0) {
          categories.push({ name: "校区", key: "area" });
        }
        if (filterData.gradeFilters && filterData.gradeFilters.length > 0) {
          categories.push({ name: "年级", key: "grade" });
        }
        if (filterData.subjectFilters && filterData.subjectFilters.length > 0) {
          categories.push({ name: "科目", key: "subject" });
        }
        if (filterData.teacherFilters && filterData.teacherFilters.length > 0) {
          categories.push({ name: "教师", key: "teacher" });
        }
        if (filterData.timeFilters && filterData.timeFilters.length > 0) {
          categories.push({ name: "时间", key: "time" });
        }
        if (
          filterData.custom1Filters &&
          filterData.custom1Filters.length > 0 &&
          filterData.custom1FilterName
        ) {
          categories.push({
            name: filterData.custom1FilterName,
            key: "custom1",
          });
        }
        if (
          filterData.custom2Filters &&
          filterData.custom2Filters.length > 0 &&
          filterData.custom2FilterName
        ) {
          categories.push({
            name: filterData.custom2FilterName,
            key: "custom2",
          });
        }
        if (
          filterData.custom3Filters &&
          filterData.custom3Filters.length > 0 &&
          filterData.custom3FilterName
        ) {
          categories.push({
            name: filterData.custom3FilterName,
            key: "custom3",
          });
        }
        if (
          filterData.custom4Filters &&
          filterData.custom4Filters.length > 0 &&
          filterData.custom4FilterName
        ) {
          categories.push({
            name: filterData.custom4FilterName,
            key: "custom4",
          });
        }
        this.initialFilterCategories = categories;
      }

      // 获取维度到索引的映射
      const getDimensionIndex = (key) => {
        const categoryKeys = this.filterCategories.map((cat) => cat.key);
        return categoryKeys.indexOf(key);
      };

      // 存储筛选数据，只更新当前维度之后的维度
      // 如果指定了 currentIndex，只更新该索引之后的维度
      const shouldUpdate = (dimensionKey) => {
        // 如果 skipKey 是当前维度，跳过
        if (skipKey === dimensionKey) {
          return false;
        }
        // 如果指定了 currentIndex，只更新该索引之后的维度
        if (currentIndex !== null && currentIndex !== undefined) {
          const dimensionIndex = getDimensionIndex(dimensionKey);
          // 如果维度索引小于等于当前索引，不更新（保持原值）
          if (dimensionIndex <= currentIndex) {
            return false;
          }
        }
        return true;
      };

      if (shouldUpdate("area")) {
        this.areaFilters = filterData.areaFilters || [];
      }
      if (shouldUpdate("grade")) {
        this.gradeFilters = filterData.gradeFilters || [];
      }
      if (shouldUpdate("subject")) {
        this.subjectFilters = filterData.subjectFilters || [];
      }
      if (shouldUpdate("teacher")) {
        this.teacherFilters = filterData.teacherFilters || [];
      }
      if (shouldUpdate("time")) {
        this.timeFilters = filterData.timeFilters || [];
      }
      if (shouldUpdate("custom1")) {
        this.custom1Filters = filterData.custom1Filters || [];
        this.custom1FilterName = filterData.custom1FilterName || "";
      }
      if (shouldUpdate("custom2")) {
        this.custom2Filters = filterData.custom2Filters || [];
        this.custom2FilterName = filterData.custom2FilterName || "";
      }
      if (shouldUpdate("custom3")) {
        this.custom3Filters = filterData.custom3Filters || [];
        this.custom3FilterName = filterData.custom3FilterName || "";
      }
      if (shouldUpdate("custom4")) {
        this.custom4Filters = filterData.custom4Filters || [];
        this.custom4FilterName = filterData.custom4FilterName || "";
      }

      // 如果弹层已打开，更新当前分类的选项
      if (this.isShowPopupList) {
        this.$nextTick(() => {
          this.updateCurrentFilterOptions();
        });
      }

      // 向父组件发送筛选数据更新事件
      this.$emit("filter-data-updated", {
        areaFilters: this.areaFilters,
        gradeFilters: this.gradeFilters,
        subjectFilters: this.subjectFilters,
        teacherFilters: this.teacherFilters,
        timeFilters: this.timeFilters,
        custom1Filters: this.custom1Filters,
        custom2Filters: this.custom2Filters,
        custom3Filters: this.custom3Filters,
        custom4Filters: this.custom4Filters,
        custom1FilterName: this.custom1FilterName,
        custom2FilterName: this.custom2FilterName,
        custom3FilterName: this.custom3FilterName,
        custom4FilterName: this.custom4FilterName,
      });
    },
    // 选择筛选选项
    selectSchoolType(categoryIndex) {
      console.log("选择筛选分类:", categoryIndex);

      // 只有在临时状态为空时才初始化（保留用户之前的选择）
      if (
        this.tempSelectedFilters.length === 0 &&
        this.tempSelectedCampuses.length === 0 &&
        this.tempSelectedTimeSlots.length === 0
      ) {
        // 初始化临时状态（将当前实际状态复制到临时状态）
        this.tempSelectedFilters = [...this.selectedFilters];
        this.tempSelectedCampuses = [...this.selectedCampuses];
        this.tempSelectedTimeSlots = [...this.selectedTimeSlots];
      }

      // 显示弹层
      document.documentElement.style.overflow = "hidden";
      this.isShowPopupList = true;
      // 设置当前筛选分类
      this.currentFilterCategory = categoryIndex;
      this.updateCurrentFilterOptions();

      // 如果是时间筛选，添加滚动监听器
      const currentCategory = this.filterCategories[categoryIndex];
      if (currentCategory && currentCategory.key === "time") {
        this.$nextTick(() => {
          this.addScrollListener();
        });
      }

      // 向父组件发送筛选点击事件，传递分类索引和对应的筛选数据
      const filterInfo = {
        categoryIndex,
        filterData: this.getFilterDataByCategory(categoryIndex),
      };

      this.$emit("filter-click", filterInfo);
    },
    // 根据分类索引获取对应的筛选数据
    getFilterDataByCategory(categoryIndex) {
      const category = this.filterCategories[categoryIndex];
      if (!category) {
        return null;
      }

      switch (category.key) {
        case "area":
          return {
            type: "area",
            data: this.areaFilters,
          };
        case "time":
          return {
            type: "time",
            data: this.timeFilters,
          };
        case "subject":
          return {
            type: "subject",
            data: this.subjectFilters,
          };
        case "teacher":
          return {
            type: "teacher",
            data: this.teacherFilters,
          };
        case "grade":
          return {
            type: "grade",
            data: this.gradeFilters,
          };
        case "custom1":
          return {
            type: "custom1",
            data: this.custom1Filters,
          };
        case "custom2":
          return {
            type: "custom2",
            data: this.custom2Filters,
          };
        case "custom3":
          return {
            type: "custom3",
            data: this.custom3Filters,
          };
        case "custom4":
          return {
            type: "custom4",
            data: this.custom4Filters,
          };
        default:
          return null;
      }
    },
    // 切换筛选分类
    switchFilterCategory(index) {
      this.currentFilterCategory = index;
      this.updateCurrentFilterOptions();

      // 滚动到被点击的分类标签，确保它在可视区域内
      this.$nextTick(() => {
        const container = this.$refs.filterCategoriesContainer;
        if (container) {
          const targetItem = container.querySelector(
            `[data-category-index="${index}"]`
          );
          if (targetItem) {
            // 计算目标元素相对于容器的位置
            const containerRect = container.getBoundingClientRect();
            const targetRect = targetItem.getBoundingClientRect();
            const containerScrollLeft = container.scrollLeft;

            // 计算目标元素在容器中的位置
            const targetLeft =
              targetRect.left - containerRect.left + containerScrollLeft;
            const targetWidth = targetRect.width;
            const containerWidth = container.clientWidth;
            // 额外的滚动偏移量（多滚动一点点）
            const extraOffset = 40;

            // 如果目标元素在左侧边缘外，滚动到左侧（多滚动一点点）
            if (targetRect.left < containerRect.left) {
              container.scrollTo({
                left: Math.max(0, targetLeft - extraOffset),
                behavior: "smooth",
              });
            }
            // 如果目标元素在右侧边缘外，滚动到右侧（多滚动一点点）
            else if (targetRect.right > containerRect.right) {
              container.scrollTo({
                left: targetLeft + targetWidth - containerWidth + extraOffset,
                behavior: "smooth",
              });
            }
            // 如果目标元素在可视区域内，尝试居中显示（多滚动一点点）
            else {
              // 让标签居中显示，并添加额外偏移
              const centerOffset =
                targetLeft - containerWidth / 2 + targetWidth / 2;
              container.scrollTo({
                left: Math.max(0, centerOffset - extraOffset),
                behavior: "smooth",
              });
            }
          }
        }
      });

      // 如果是时间筛选，添加滚动监听器
      const currentCategory = this.filterCategories[index];
      if (currentCategory && currentCategory.key === "time") {
        this.$nextTick(() => {
          this.addScrollListener();
        });
      } else {
        // 切换到其他分类时，移除滚动监听器
        this.removeScrollListener();
      }
    },
    // 更新当前分类的选项
    updateCurrentFilterOptions() {
      const category = this.filterCategories[this.currentFilterCategory];
      console.log(
        "更新筛选选项 - 当前分类:",
        category,
        "currentFilterCategory:",
        this.currentFilterCategory
      );

      // 检查 category 是否存在
      if (!category) {
        console.warn("筛选分类不存在:", this.currentFilterCategory);
        this.currentFilterOptions = [];
        return;
      }

      switch (category.key) {
        case "area":
          // 地点使用二级筛选，显示地区列表
          this.currentFilterOptions = this.areaFilters.map((item) => ({
            name: item.name,
            key: item.key,
            subValues: item.subValues || [],
          }));
          // 如果没有选中的地区，默认选中第一个
          if (!this.selectedArea && this.currentFilterOptions.length > 0) {
            this.selectedArea = this.currentFilterOptions[0];
          }
          break;
        case "time":
          // 时间使用三层筛选，显示季节/假期列表
          this.currentFilterOptions = this.timeFilters.map((item) => ({
            name: item.name,
            key: item.key,
            subValues: item.subValues || [],
          }));
          // 如果没有选中的季节，默认选中第一个
          if (
            !this.selectedTimeSeason &&
            this.currentFilterOptions.length > 0
          ) {
            this.selectedTimeSeason = this.currentFilterOptions[0];
            // 同时设置默认的期次选择
            if (
              this.selectedTimeSeason.subValues &&
              this.selectedTimeSeason.subValues.length > 0
            ) {
              this.selectedTimePhase = this.selectedTimeSeason.subValues[0];
            }
          }
          break;
        case "subject":
          this.currentFilterOptions = this.subjectFilters.map((item) => ({
            name: item.name,
            key: item.key || item.name, // 如果没有key，使用name作为key
          }));
          break;
        case "teacher":
          this.currentFilterOptions = this.teacherFilters.map((item) => ({
            name: item.name,
            key: item.key || item.code || item.name, // 优先使用key，然后是code，最后是name
            logo: item.logo,
            pinyinName: item.pinyinName,
          }));
          // 初始化当前字母为第一个可用字母
          this.$nextTick(() => {
            const letters = Object.keys(this.groupedTeachers);
            if (letters.length > 0) {
              this.currentLetter = letters[0];
            }
          });
          break;
        case "grade":
          this.currentFilterOptions = this.gradeFilters;
          break;
        case "custom1":
          this.currentFilterOptions = this.custom1Filters.map((item) => ({
            name: item.name,
            key: item.key || item.name, // 如果没有key，使用name作为key
          }));
          break;
        case "custom2":
          this.currentFilterOptions = this.custom2Filters.map((item) => ({
            name: item.name,
            key: item.key || item.name, // 如果没有key，使用name作为key
          }));
          break;
        case "custom3":
          this.currentFilterOptions = this.custom3Filters.map((item) => ({
            name: item.name,
            key: item.key || item.name, // 如果没有key，使用name作为key
          }));
          break;
        case "custom4":
          this.currentFilterOptions = this.custom4Filters.map((item) => ({
            name: item.name,
            key: item.key || item.name, // 如果没有key，使用name作为key
          }));
          break;
        default:
          this.currentFilterOptions = [];
      }
    },
    // 选择筛选选项
    selectFilterOption(item) {
      const category = this.filterCategories[this.currentFilterCategory];

      // 检查 category 是否存在
      if (!category) {
        console.warn("筛选分类不存在:", this.currentFilterCategory);
        return;
      }

      const currentCategoryIndex = this.currentFilterCategory;
      const currentCategoryKey = category.key;

      if (category.key === "area") {
        // 地点二级筛选：选择地区
        this.selectedArea = item;
      } else if (category.key === "time") {
        // 时间三级筛选：选择季节/假期
        this.selectedTimeSeason = item;
        // 重置期次选择，并设置默认期次
        this.selectedTimePhase = null;
        if (item.subValues && item.subValues.length > 0) {
          this.selectedTimePhase = item.subValues[0];
        }
      } else {
        // 其他筛选：直接选择（更新临时状态）
        const option =
          typeof item === "string" ? { name: item, key: item } : item;
        const existingIndex = this.tempSelectedFilters.findIndex(
          (filter) => filter.key === option.key
        );

        if (existingIndex > -1) {
          // 如果已存在，则移除
          this.tempSelectedFilters.splice(existingIndex, 1);
        } else {
          // 如果不存在，则添加
          this.tempSelectedFilters.push(option);
        }
      }

      // 级联逻辑：选择前面的维度后，刷新后面维度的选项
      this.refreshLaterDimensions(currentCategoryIndex);

      this.updateFilteredCourseCount();
    },
    // 选择校区（二级筛选）
    selectCampus(campus) {
      const existingIndex = this.tempSelectedCampuses.findIndex(
        (c) => c.key === campus.key
      );

      if (existingIndex > -1) {
        // 如果已存在，则移除
        this.tempSelectedCampuses.splice(existingIndex, 1);
      } else {
        // 如果不存在，则添加
        const campusWithArea = {
          ...campus,
          areaKey: this.selectedArea.key,
          areaName: this.selectedArea.name,
        };
        this.tempSelectedCampuses.push(campusWithArea);
      }

      // 级联逻辑：选择地点后，刷新后面维度的选项
      const currentCategoryIndex = this.getCategoryIndex("area");
      this.refreshLaterDimensions(currentCategoryIndex);

      this.updateFilteredCourseCount();
    },
    // 检查校区是否已选中
    isCampusSelected(campus) {
      return this.tempSelectedCampuses.some((c) => c.key === campus.key);
    },
    // 选择时间期次（第二层）
    selectTimePhase(phase) {
      if (!phase || !phase.key) {
        console.warn("selectTimePhase: phase 参数无效", phase);
        return;
      }

      this.selectedTimePhase = phase;
      // 滚动到对应的期次分组
      this.$nextTick(() => {
        const element = document.querySelector(
          `[data-phase-section="${phase.key}"]`
        );
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "start",
          });
        }
      });
    },
    // 处理时间筛选区域滚动
    handleTimeSlotsScroll() {
      if (!this.selectedTimeSeason || !this.selectedTimeSeason.subValues) {
        return;
      }

      const scrollContainer = this.$refs.timeSlotsList;
      if (!scrollContainer) {
        return;
      }

      const scrollTop = scrollContainer.scrollTop;
      const containerHeight = scrollContainer.clientHeight;
      const containerTop = scrollTop;
      const containerBottom = scrollTop + containerHeight;

      // 找到当前滚动位置对应的期次
      let currentPhase = null;
      let maxVisibleArea = 0;

      this.selectedTimeSeason.subValues.forEach((phase) => {
        const element = document.querySelector(
          `[data-phase-section="${phase.key}"]`
        );
        if (element) {
          const rect = element.getBoundingClientRect();
          const containerRect = scrollContainer.getBoundingClientRect();
          const elementTop = rect.top - containerRect.top + scrollTop;
          const elementBottom = elementTop + rect.height;

          // 计算元素在可视区域内的可见面积
          const visibleTop = Math.max(elementTop, containerTop);
          const visibleBottom = Math.min(elementBottom, containerBottom);
          const visibleHeight = Math.max(0, visibleBottom - visibleTop);

          // 选择可见面积最大的期次
          if (visibleHeight > maxVisibleArea) {
            maxVisibleArea = visibleHeight;
            currentPhase = phase;
          }
        }
      });

      // 如果找到了对应的期次且与当前选中的不同，则更新选中状态
      if (
        currentPhase &&
        (!this.selectedTimePhase ||
          this.selectedTimePhase.key !== currentPhase.key)
      ) {
        this.selectedTimePhase = currentPhase;
      }
    },
    // 选择时间段（第三层）
    selectTimeSlot(slot) {
      // 检查 slot 参数是否有效
      if (!slot || !slot.key) {
        console.warn("selectTimeSlot: slot 参数无效", slot);
        return;
      }

      // 检查必要的上下文数据是否存在
      if (!this.selectedTimeSeason || !this.selectedTimePhase) {
        console.warn("selectTimeSlot: 缺少必要的上下文数据", {
          selectedTimeSeason: this.selectedTimeSeason,
          selectedTimePhase: this.selectedTimePhase,
        });
        return;
      }

      const existingIndex = this.tempSelectedTimeSlots.findIndex(
        (s) => s.key === slot.key
      );

      if (existingIndex > -1) {
        // 如果已存在，则移除
        this.tempSelectedTimeSlots.splice(existingIndex, 1);
      } else {
        // 如果不存在，则添加
        const slotWithContext = {
          ...slot,
          seasonKey: this.selectedTimeSeason.key,
          seasonName: this.selectedTimeSeason.name,
          phaseKey: this.selectedTimePhase.key,
          phaseName: this.selectedTimePhase.name,
        };
        this.tempSelectedTimeSlots.push(slotWithContext);
      }

      // 级联逻辑：选择时间后，刷新后面维度的选项
      const currentCategoryIndex = this.getCategoryIndex("time");
      this.refreshLaterDimensions(currentCategoryIndex);

      this.updateFilteredCourseCount();
    },
    // 检查时间段是否已选中
    isTimeSlotSelected(slot) {
      if (!slot || !slot.key) {
        return false;
      }
      return this.tempSelectedTimeSlots.some((s) => s.key === slot.key);
    },
    // 滚动到指定期次
    scrollToTimePhase(phaseKey) {
      // 切换到时间筛选分类
      this.currentFilterCategory = 1; // 时间是第二个分类
      this.updateCurrentFilterOptions();

      // 找到对应的期次并设置季节
      const phase = this.timeFilters
        .flatMap((season) => season.subValues)
        .find((p) => p.key === phaseKey);

      if (phase) {
        const season = this.timeFilters.find((s) =>
          s.subValues.some((p) => p.key === phaseKey)
        );
        if (season) {
          this.selectedTimeSeason = season;
          this.selectedTimePhase = phase;
        }
      }

      this.$nextTick(() => {
        const element = document.querySelector(
          `[data-phase-key="${phaseKey}"]`
        );
        if (element) {
          element.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
      });
    },
    // 检查选项是否已选中
    isOptionSelected(item) {
      const option =
        typeof item === "string" ? { name: item, key: item } : item;
      return this.tempSelectedFilters.some(
        (filter) => filter.key === option.key
      );
    },
    // 移除已选筛选条件
    removeSelectedFilter(index) {
      this.tempSelectedFilters.splice(index, 1);
      this.updateFilteredCourseCount();
    },
    // 移除已选校区
    removeSelectedCampus(index) {
      this.tempSelectedCampuses.splice(index, 1);
      this.updateFilteredCourseCount();
    },
    // 移除已选时间段
    removeSelectedTimeSlot(index) {
      this.tempSelectedTimeSlots.splice(index, 1);
      this.updateFilteredCourseCount();
    },
    // 重置筛选条件
    resetFilters() {
      // 清空所有临时筛选状态
      this.tempSelectedFilters = [];
      this.selectedArea = null;
      this.tempSelectedCampuses = [];
      this.selectedTimeSeason = null;
      this.selectedTimePhase = null;
      this.tempSelectedTimeSlots = [];

      // 重新调用筛选项接口，获取初始筛选数据（不传任何筛选参数）
      this.getFilterData(null, null, null);

      this.updateFilteredCourseCount();
    },
    // 确认筛选条件
    confirmFilters() {
      // 在清空临时状态前，先构建要发送的数据
      const filterData = {
        selectedFilters: [...this.tempSelectedFilters],
        selectedCampuses: [...this.tempSelectedCampuses],
        selectedTimeSlots: [...this.tempSelectedTimeSlots],
        // 添加按类型分类的筛选数据
        areaFilters: this.tempSelectedCampuses.map((campus) => campus.key),
        timeFilters: this.tempSelectedTimeSlots.map((slot) => slot.key),
        gradeFilters: this.getSelectedFiltersByType("grade"),
        subjectFilters: this.getSelectedFiltersByType("subject"),
        teacherFilters: this.getSelectedFiltersByType("teacher"),
        custom1Filters: this.getSelectedFiltersByType("custom1"),
        custom2Filters: this.getSelectedFiltersByType("custom2"),
        custom3Filters: this.getSelectedFiltersByType("custom3"),
        custom4Filters: this.getSelectedFiltersByType("custom4"),
      };

      // 将临时筛选状态应用到实际筛选状态
      this.selectedFilters = [...this.tempSelectedFilters];
      this.selectedCampuses = [...this.tempSelectedCampuses];
      this.selectedTimeSlots = [...this.tempSelectedTimeSlots];

      // 清空临时状态，确保下次打开弹层时重新初始化
      this.tempSelectedFilters = [];
      this.tempSelectedCampuses = [];
      this.tempSelectedTimeSlots = [];

      // 向父组件发送筛选确认事件（包含按类型分类的筛选数据）
      this.$emit("filter-confirm", filterData);
      this.closePopupList();
    },
    // 应用筛选条件
    applyFilters() {
      // 这里可以根据已选择的筛选条件来过滤课程列表
      console.log("应用筛选条件:", this.selectedFilters);
      // 向父组件发送筛选结果
      this.$emit("filter-confirmed", {
        selectedFilters: this.selectedFilters,
        selectedCampuses: this.selectedCampuses,
        selectedTimeSlots: this.selectedTimeSlots,
      });
    },
    // 更新筛选后的课程数量
    updateFilteredCourseCount() {
      // 向父组件发送筛选数量更新事件，让父组件调用接口获取实际数量
      this.$emit("filter-count-update", {
        activityId: parseInt(this.activityId),
        areaFilters: this.tempSelectedCampuses.map((campus) => campus.key),
        timeFilters: this.tempSelectedTimeSlots.map((slot) => slot.key),
        gradeFilters: this.getSelectedFiltersByType("grade"),
        subjectFilters: this.getSelectedFiltersByType("subject"),
        teacherFilters: this.getSelectedFiltersByType("teacher"),
        custom1Filters: this.getSelectedFiltersByType("custom1"),
        custom2Filters: this.getSelectedFiltersByType("custom2"),
        custom3Filters: this.getSelectedFiltersByType("custom3"),
        custom4Filters: this.getSelectedFiltersByType("custom4"),
      });
    },
    // 更新班级数量（由父组件调用）
    updateClassCount(count) {
      this.filteredCourseCount = count;
    },
    // 根据类型获取已选择的筛选条件
    getSelectedFiltersByType(type) {
      return this.tempSelectedFilters
        .filter((filter) => {
          const filterKey = filter.key || filter.name;
          switch (type) {
            case "grade":
              return (
                this.gradeFilters &&
                this.gradeFilters.some((item) => item.key === filterKey)
              );
            case "subject":
              return (
                this.subjectFilters &&
                this.subjectFilters.some(
                  (item) => (item.key || item.name) === filterKey
                )
              );
            case "teacher":
              return (
                this.teacherFilters &&
                this.teacherFilters.some(
                  (item) => (item.key || item.code || item.name) === filterKey
                )
              );
            case "custom1":
              return (
                this.custom1Filters &&
                this.custom1Filters.some(
                  (item) => (item.key || item.name) === filterKey
                )
              );
            case "custom2":
              return (
                this.custom2Filters &&
                this.custom2Filters.some(
                  (item) => (item.key || item.name) === filterKey
                )
              );
            case "custom3":
              return (
                this.custom3Filters &&
                this.custom3Filters.some(
                  (item) => (item.key || item.name) === filterKey
                )
              );
            case "custom4":
              return (
                this.custom4Filters &&
                this.custom4Filters.some(
                  (item) => (item.key || item.name) === filterKey
                )
              );
            default:
              return false;
          }
        })
        .map((filter) => filter.key || filter.name);
    },
    // 获取筛选后的班级列表
    getFilteredClassList() {
      // 向父组件发送获取班级列表的请求
      this.$emit("get-filtered-class-list", {
        selectedFilters: this.selectedFilters,
        selectedCampuses: this.selectedCampuses,
        selectedTimeSlots: this.selectedTimeSlots,
      });
    },
    // 关闭弹窗
    closePopupList() {
      document.documentElement.style.overflow = "scroll";
      this.isShowPopupList = false;
      // 移除滚动监听器
      this.removeScrollListener();
      // 注意：不重置临时状态，保留用户的选择以便下次打开时显示
    },
    // 添加滚动监听器
    addScrollListener() {
      const timeSlotsList = this.$refs.timeSlotsList;
      if (timeSlotsList) {
        // 使用节流函数优化滚动性能
        this.throttledScrollHandler = this.throttle(
          this.handleTimeSlotsScroll,
          100
        );
        timeSlotsList.addEventListener("scroll", this.throttledScrollHandler);
      }
    },
    // 移除滚动监听器
    removeScrollListener() {
      const timeSlotsList = this.$refs.timeSlotsList;
      if (timeSlotsList && this.throttledScrollHandler) {
        timeSlotsList.removeEventListener(
          "scroll",
          this.throttledScrollHandler
        );
      }
    },
    // 节流函数
    throttle(func, delay) {
      let timeoutId;
      let lastExecTime = 0;
      return function (...args) {
        const currentTime = Date.now();

        if (currentTime - lastExecTime > delay) {
          func.apply(this, args);
          lastExecTime = currentTime;
        } else {
          clearTimeout(timeoutId);
          timeoutId = setTimeout(() => {
            func.apply(this, args);
            lastExecTime = Date.now();
          }, delay - (currentTime - lastExecTime));
        }
      };
    },
    // 检查是否有选中的筛选项（基于确认后的状态）
    hasSelectedFilters(categoryKey) {
      switch (categoryKey) {
        case "area":
          return this.selectedCampuses.length > 0;
        case "time":
          return this.selectedTimeSlots.length > 0;
        case "subject":
        case "teacher":
        case "grade":
        case "custom1":
        case "custom2":
        case "custom3":
        case "custom4":
          return this.selectedFilters.some((filter) => {
            // 根据分类类型检查对应的筛选数据
            const filterData = this.getFilterDataByCategory(
              this.filterCategories.findIndex((cat) => cat.key === categoryKey)
            );
            if (!filterData || !filterData.data) {
              return false;
            }
            // 使用更灵活的匹配方式
            return filterData.data.some((item) => {
              const itemKey = item.key || item.code || item.name;
              const filterKey = filter.key || filter.name;
              return itemKey === filterKey;
            });
          });
        default:
          return false;
      }
    },
    // 处理教师头像加载失败
    handleAvatarError(event) {
      // 设置默认头像或隐藏图片
      event.target.style.display = "none";
      // 或者可以设置一个默认头像
      // event.target.src = '/path/to/default-avatar.png';
    },
    // 滚动到指定字母的教师分组
    scrollToLetter(letter) {
      this.currentLetter = letter;
      this.$nextTick(() => {
        const teacherListArea = this.$refs.teacherListArea;
        const letterGroup = teacherListArea?.querySelector(
          `[data-letter="${letter}"]`
        );
        if (letterGroup && teacherListArea) {
          // 计算相对于容器的滚动位置
          const containerTop = teacherListArea.getBoundingClientRect().top;
          const elementTop = letterGroup.getBoundingClientRect().top;
          const scrollOffset =
            elementTop - containerTop + teacherListArea.scrollTop;

          teacherListArea.scrollTo({
            top: scrollOffset,
            behavior: "smooth",
          });
        }
      });
    },
    // 处理教师列表滚动，更新当前活动字母
    handleTeacherListScroll() {
      const teacherListArea = this.$refs.teacherListArea;
      if (!teacherListArea) return;

      const scrollTop = teacherListArea.scrollTop;
      const containerTop = teacherListArea.getBoundingClientRect().top;

      // 找到当前滚动位置对应的字母分组
      let currentLetter = null;
      const letters = Object.keys(this.groupedTeachers);

      for (let i = letters.length - 1; i >= 0; i--) {
        const letter = letters[i];
        const element = teacherListArea.querySelector(
          `[data-letter="${letter}"]`
        );
        if (element) {
          const elementTop = element.getBoundingClientRect().top;
          const relativeTop = elementTop - containerTop;

          // 如果分组的顶部已经在容器顶部或上方，则认为是当前分组
          if (relativeTop <= 10) {
            currentLetter = letter;
            break;
          }
        }
      }

      if (currentLetter && currentLetter !== this.currentLetter) {
        this.currentLetter = currentLetter;
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../less/variables.less";

/*筛选器区域*/
.filter_section {
  padding: 0 0 0 32px;
  width: 750px;
  height: 480px;
  background: linear-gradient(180deg, #ffeedb 0%, #f6f7fc 60%);

  &.empty {
    height: 400px;
  }

  .filter_container {
    display: flex;
    overflow-x: auto;
    padding-top: 16px;
    /* 隐藏滚动条但保持滚动功能 */
    &::-webkit-scrollbar {
      display: none;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }

  .filter_item {
    flex-shrink: 0;
    text-align: center;
    min-width: 128px;
    padding: 15px 0;
    margin-right: 24px;

    background: rgba(255, 255, 255, 0.7);
    border-radius: 16px;
    display: flex;

    justify-content: center;
    cursor: pointer;
    position: relative;
    align-items: center;

    &:active {
      transform: translateY(0);
    }

    &.active {
      .filter_label {
        color: #21c2a0;
        font-weight: 600;
      }
      .filter_arrow {
        background-image: url("../assets/arrow-active.png");
      }
    }

    .filter_label {
      font-size: 24px;
      color: #464b58;
      line-height: 26px;
    }

    .filter_arrow {
      width: 24px;
      height: 24px;
      background-image: url("../assets/arrow-down.png");
      background-size: contain;
      background-repeat: no-repeat;
      background-position: center;
      margin-left: 12px;
    }

    &:hover .filter_arrow {
      transform: rotate(180deg);
    }
  }

  .filter_placeholder {
    flex-shrink: 0;
    width: 200px;
    height: 56px;
  }
}

/*筛选弹层*/
.filter_popup_bg {
  position: fixed;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  z-index: 1001;
  background: rgba(0, 0, 0, 0.5);

  .filter_popup_content {
    position: absolute;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    max-width: 750px;
    margin: 0 auto;
    background: @bg-primary;
    border-radius: 20px 20px 0 0;
    height: 90vh;
    max-height: 1304px;
    display: flex;
    flex-direction: column;

    .filter_popup_header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 48px 32px 14px;

      .filter_popup_title {
        font-size: 36px;
        font-weight: 600;
        color: @text-primary;
      }

      .filter_popup_close {
        width: 40px;
        height: 40px;
        background-image: url("../assets/close.png");
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        cursor: pointer;
      }
    }

    .filter_categories {
      display: flex;
      padding: 6px 40px 20px;
      border-bottom: 2px solid #f6f7fc;
      overflow-x: auto;

      .filter_category_item {
        flex-shrink: 0;
        font-size: 28px;

        color: #868c9b;
        cursor: pointer;
        position: relative;
        margin-right: 80px;

        &:last-child {
          margin-right: 0;
        }

        &.active {
          color: @text-primary;
          font-weight: 600;

          &::after {
            content: "";
            position: absolute;
            bottom: -20px;
            left: 50%;
            transform: translateX(-50%);
            width: 24px;
            height: 6px;
            background: linear-gradient(90deg, #20e8b3 2%, #04cace 100%);
            border-radius: 96px;
          }
        }
      }
    }

    .filter_content_area {
      flex: 1;
      overflow-y: auto;
      min-height: 730px;
      height: 100%;

      box-sizing: border-box;

      // Loading 状态样式
      .filter_loading {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 1002;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .loading_container {
          width: 204px;
          height: 204px;
          border-radius: 24px;
          background: #ffffff;
          box-shadow: 0px 8px 48px 0px rgba(0, 0, 0, 0.08);
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
        }

        .loading_gif {
          width: 112px;
          height: 84px;
        }

        .loading_text {
          font-size: 22px;
          color: @text-light;
        }
      }

      // 地点二级筛选容器
      .area_filter_container {
        display: flex;
        height: 100%;

        .area_list {
          width: 216px;
          padding-bottom: 96px;
          background: #f6f7fc;

          .area_item {
            padding: 32px 0 32px 38px;
            font-size: 28px;
            color: @text-secondary;
            cursor: pointer;

            margin-bottom: 4px;

            &.active {
              background: #fff;
              color: @accent-color;
              font-weight: 600;
              position: relative;

              // 第一个扇形 - 右上角
              .sector-90:first-child {
                position: absolute;
                top: -32px;
                right: 0;
                width: 32px;
                height: 32px;
                z-index: 1;
                transform: rotate(90deg);
              }

              // 第二个扇形 - 右下角
              .sector-90:last-child {
                position: absolute;
                bottom: -32px;
                right: 0;
                width: 32px;
                height: 32px;
                z-index: 1;
              }
            }

            // 90度扇形样式
            .sector-90 {
              position: relative;
              width: 32px;
              height: 32px;
              background: #fff;

              &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: #f6f7fc;
                border-radius: 0 50% 0 0;
              }
            }
          }
        }

        .campus_list {
          flex: 1;
          overflow-y: auto;
          padding: 32px 40px;
          padding-bottom: 96px;
          .campus_item {
            display: flex;
            align-items: center;
            padding: 16px 0;
            cursor: pointer;

            .campus_checkbox {
              margin-right: 16px;

              .checkbox {
                width: 40px;
                height: 40px;
                background-image: url("https://g.xdfimage.cn/upload/abbb9bcc0cfd0e2634adca8f162ef884.png");
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                border: none;
                border-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;

                &.checked {
                  background-image: url("../assets/checked.png") !important;
                  background-size: contain;
                  background-repeat: no-repeat;
                  background-position: center;
                  border: none;

                  .checkbox-icon {
                    display: none;
                  }
                }
              }
            }

            .campus_text {
              font-size: 30px;
              color: @text-primary;
              flex: 1;
            }
          }
        }
      }

      // 时间三级筛选容器
      .time_filter_container {
        display: flex;
        height: 100%;

        .no-filter-options {
          width: 100%;
          padding: 20px;
          padding-top: 400px;
          text-align: center;
          font-size: 24px;
          color: @text-light;
        }

        .time_season_list {
          width: 216px;
          background: #f6f7fc;
          padding-bottom: 96px;

          .time_season_item {
            padding: 32px 0 32px 38px;
            font-size: 28px;
            color: @text-secondary;
            cursor: pointer;
            margin-bottom: 4px;

            &.active {
              background: #fff;
              color: @accent-color;
              font-weight: 600;
              position: relative;

              // 第一个扇形 - 右上角
              .sector-90:first-child {
                position: absolute;
                top: -32px;
                right: 0;
                width: 32px;
                height: 32px;
                z-index: 1;
                transform: rotate(90deg);
              }

              // 第二个扇形 - 右下角
              .sector-90:last-child {
                position: absolute;
                bottom: -32px;
                right: 0;
                width: 32px;
                height: 32px;
                z-index: 1;
              }
            }

            // 90度扇形样式
            .sector-90 {
              position: relative;
              width: 32px;
              height: 32px;
              background: #fff;

              &::before {
                content: "";
                position: absolute;
                top: 0;
                left: 0;
                width: 100%;
                height: 100%;
                background: #f6f7fc;
                border-radius: 0 50% 0 0;
              }
            }
          }
        }

        .time_content_area {
          flex: 1;
          display: flex;
          flex-direction: column;
          padding-top: 16px;
          padding-bottom: 96px;

          .time_phase_tabs {
            display: flex;
            overflow-x: auto;
            padding: 16px 0 16px 40px;

            /* 隐藏滚动条但保持滚动功能 */
            &::-webkit-scrollbar {
              display: none;
            }
            -ms-overflow-style: none;
            scrollbar-width: none;

            .time_phase_tab {
              flex-shrink: 0;
              padding: 8px 16px;
              font-size: 24px;
              color: #868c9b;
              background: #f6f7fc;
              border-radius: 64px;
              cursor: pointer;
              white-space: nowrap;
              margin-right: 18px;

              &:last-child {
                margin-right: 0;
              }

              &.active {
                background: #2cd4b0;
                color: white;
                font-weight: 600;
              }
            }
          }

          .time_slots_list {
            flex: 1;
            overflow-y: auto;

            .phase_section {
              margin-bottom: 24px;

              .phase_title {
                font-size: 24px;
                color: #868c9b;
                padding: 52px 40px 28px;
              }

              .time_slot_item {
                display: flex;
                align-items: center;
                padding: 12px 0;
                cursor: pointer;
                padding: 32px 40px;
                font-size: 28px;
                color: #21242c;

                .time_slot_checkbox {
                  margin-right: 16px;

                  .checkbox {
                    width: 40px;
                    height: 40px;
                    background-image: url("https://g.xdfimage.cn/upload/abbb9bcc0cfd0e2634adca8f162ef884.png");
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                    border: none;
                    border-radius: 6px;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    &.checked {
                      background-image: url("../assets/checked.png") !important;
                      background-size: contain;
                      background-repeat: no-repeat;
                      background-position: center;
                      border: none;

                      .checkbox-icon {
                        display: none;
                      }
                    }
                  }
                }

                .time_slot_text {
                  font-size: 30px;
                  color: @text-primary;
                  flex: 1;
                }

                // 选中状态时文字加粗
                &:has(.checkbox.checked) .time_slot_text {
                  font-weight: 600;
                }
              }
            }
          }
        }
      }

      // 教师筛选容器（带字母锚点）
      .teacher_filter_container {
        display: flex;
        height: 100%;
        position: relative;

        .teacher_list_area {
          flex: 1;
          overflow-y: auto;
          padding-bottom: 96px;

          .no-filter-options {
            padding: 20px;
            padding-top: 400px;
            text-align: center;
            font-size: 24px;
            color: @text-light;
          }

          .teacher_group {
            .teacher_group_title {
              position: sticky;
              top: 0;
              color: #868c9b;
              padding: 52px 40px 28px;
              font-size: 24px;

              z-index: 10;
            }

            .filter_option_item {
              display: flex;
              align-items: center;
              padding: 32px 40px;
              cursor: pointer;

              .filter_option_checkbox {
                margin-right: 16px;

                .checkbox {
                  width: 40px;
                  height: 40px;
                  background-image: url("https://g.xdfimage.cn/upload/abbb9bcc0cfd0e2634adca8f162ef884.png");
                  background-size: contain;
                  background-repeat: no-repeat;
                  background-position: center;
                  border: none;
                  border-radius: 6px;
                  display: flex;
                  align-items: center;
                  justify-content: center;

                  &.checked {
                    background-image: url("../assets/checked.png") !important;
                    background-size: contain;
                    background-repeat: no-repeat;
                    background-position: center;
                    border: none;

                    .checkbox-icon {
                      display: none;
                    }
                  }
                }
              }

              .teacher_avatar {
                margin-right: 16px;
                width: 72px;
                height: 72px;
                border-radius: 50%;
                overflow: hidden;
                flex-shrink: 0;

                img {
                  width: 100%;
                  height: 100%;
                  object-fit: cover;
                  border-radius: 50%;
                }
              }

              .filter_option_text {
                font-size: 30px;
                color: @text-primary;
                flex: 1;
              }
            }
          }
        }

        .letter_anchor_nav {
          position: absolute;
          right: 16px;
          top: 50%;
          transform: translateY(-50%);
          display: flex;
          flex-direction: column;
          align-items: center;
          z-index: 100;
          padding: 8px 0;
          max-height: 90%;
          overflow-y: auto;

          /* 隐藏滚动条 */
          &::-webkit-scrollbar {
            display: none;
          }
          -ms-overflow-style: none;
          scrollbar-width: none;

          .letter_anchor_item {
            padding: 4px 8px;
            font-size: 24px;
            font-weight: normal;
            line-height: 24px;
            letter-spacing: 0px;

            /* 文字图标色/03较弱 */
            color: #868c9b;
            cursor: pointer;
            user-select: none;
            text-align: center;
            min-width: 32px;

            // &.active {
            //   color: #2cd4b0;
            //   font-weight: 600;
            //   font-size: 24px;
            // }
          }
        }
      }

      .filter_options_list {
        padding-top: 16px;
        padding-bottom: 96px;
        .no-filter-options {
          padding: 20px;
          text-align: center;
          color: @text-light;
          font-size: 24px;
          padding-top: 400px;
        }

        .filter_option_item {
          display: flex;
          align-items: center;
          padding: 32px 40px;
          cursor: pointer;

          .filter_option_checkbox {
            margin-right: 16px;

            .checkbox {
              width: 40px;
              height: 40px;
              background-image: url("https://g.xdfimage.cn/upload/abbb9bcc0cfd0e2634adca8f162ef884.png");
              background-size: contain;
              background-repeat: no-repeat;
              background-position: center;
              border: none;
              border-radius: 6px;
              display: flex;
              align-items: center;
              justify-content: center;

              &.checked {
                background-image: url("../assets/checked.png");
                background-size: contain;
                background-repeat: no-repeat;
                background-position: center;
                border: none;

                .checkbox-icon {
                  display: none;
                }
              }
            }
          }

          .filter_option_text {
            font-size: 30px;
            color: @text-primary;
            flex: 1;
          }
        }
      }
    }

    .selected_filters {
      position: absolute;
      bottom: calc(130px + constant(safe-area-inset-bottom));
      bottom: calc(130px + env(safe-area-inset-bottom));
      background: #fff;
      height: 96px;
      left: 0;
      right: 0;
      padding: 16px 32px;
      border-top: 1px solid @border-light;
      display: flex;
      flex-wrap: nowrap;
      gap: 12px;
      overflow-x: auto;
      overflow-y: hidden;

      /* 隐藏滚动条但保持滚动功能 */
      &::-webkit-scrollbar {
        display: none;
      }
      -ms-overflow-style: none;
      scrollbar-width: none;

      .selected_filter_tag {
        display: flex;
        align-items: center;
        border-radius: 8px;
        opacity: 1;
        background: #f6f7fc;
        padding: 8px 8px 8px 16px;
        flex-shrink: 0;
        // white-space: nowrap; // 移除，允许时间段标签换行显示

        .tag_text {
          font-size: 24px;
          color: #464b58;
          margin-right: 8px;
          cursor: pointer;
          white-space: pre-line; // 允许 \n 换行显示（用于时间段标签）
          word-break: break-all; // 允许长文本换行
        }

        .tag_remove {
          width: 32px;
          height: 32px;
          background-image: url("../assets/remove.png");
          background-size: contain;
          background-repeat: no-repeat;
          background-position: center;
          cursor: pointer;
        }
      }
    }

    .filter_popup_actions {
      display: flex;
      padding: 24px 32px;
      padding-bottom: calc(24px + constant(safe-area-inset-bottom));
      padding-bottom: calc(24px + env(safe-area-inset-bottom));
      gap: 16px;
      border-top: 1px solid @border-light;

      .reset_btn {
        flex: 1;
        height: 80px;
        background: #f5f8fa;
        border: none;
        border-radius: 40px;
        font-size: 28px;
        color: @text-secondary;
        cursor: pointer;
      }

      .confirm_btn {
        flex: 2;
        height: 80px;
        background: linear-gradient(101deg, #20e8b3 0%, #04cace 100%);
        border: none;
        border-radius: 40px;
        font-size: 28px;
        color: white;
        font-weight: 600;
        cursor: pointer;
      }
    }
  }
}
</style>
